import React from "react";
import { motion } from "framer-motion";
import {
  FaDiscord,
  FaTwitter,
  FaYoutube,
  FaTwitch,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { Link, NavLink, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <motion.footer
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="relative z-20 bg-[#1A181C] text-gray-300 pt-12 pb-6"
    >
      {/* Top Gradient Border */}
      <div className="absolute top-0 left-0 w-full h-[4px] bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500" />

      <div className="w-[95%] sm:w-[92%] md:w-[90%] lg:max-w-[80%] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 xl:gap-10 text-center md:text-start">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start">
            <h2
              onClick={() => {
                navigate("/");
              }}
              className="text-3xl font-bold text-white mb-3 cursor-pointer"
            >
              <img
                src={require("../Asset/images/logo556.png")}
                alt="logo"
                className="mx-auto md:mx-0 h-10 hover:opacity-80 transition-opacity"
              />
            </h2>
            <h2 className="text-lg font-bold mb-1.5 gradient-text">Play Beyond Limits</h2>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs md:max-w-none">
              Level up your gaming experience with the best deals and latest releases.
            </p>
            {/* <div className="flex justify-center md:justify-start space-x-3 mt-5">
              {[
                { Icon: FaDiscord, url: "https://discord.gg" },
                { Icon: FaTwitter, url: "https://twitter.com" },
                { Icon: FaYoutube, url: "https://youtube.com" },
                { Icon: FaTwitch, url: "https://twitch.tv" },
              ].map(({ Icon, url }, idx) => (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={idx}
                  className="flex items-center justify-center w-9 h-9 rounded-lg bg-white/[0.02] border border-white/[0.04] text-gray-400 hover:bg-purple-500 hover:border-purple-400 hover:text-white hover:-translate-y-1 hover:shadow-[0_0_12px_rgba(168,85,247,0.4)] transition-all duration-300 cursor-pointer"
                >
                  <Icon size={17} />
                </a>
              ))}
            </div> */}
          </div>

          <div className="flex justify-evenly w-full">
            {/* Quick Links */}
            <div className="flex flex-col items-center md:items-start w-full">
              <h3 className="text-white text-lg font-bold mb-5 relative after:content-[''] after:absolute after:-bottom-1.5 after:left-1/2 md:after:left-0 after:-translate-x-1/2 md:after:translate-x-0 after:w-12 after:h-[2px] after:bg-purple-500">
                Quick Links
              </h3>
              <ul className="space-y-2.5 text-sm">
                {[
                  { name: "Home", path: "/" },
                  { name: "Games", path: "/games" },
                  { name: "Contact", path: "/contact" },
                ].map((link) => (
                  <li key={link.name} className="group/item flex justify-center md:justify-start">
                    <NavLink
                      to={link.path}
                      end={link.path === "/"}
                      className={({ isActive }) =>
                        `inline-flex items-center gap-1.5 transition-all duration-200 cursor-pointer hover:text-purple-400 hover:translate-x-1 ${isActive ? "text-purple-400 font-semibold" : "text-gray-400"
                        }`
                      }
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-purple-500 opacity-0 group-hover/item:opacity-100 transition-opacity duration-200 shrink-0" />
                      {link.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support */}
            <div className="flex flex-col items-center md:items-start w-full">
              <h3 className="text-white text-lg font-bold mb-5 relative after:content-[''] after:absolute after:-bottom-1.5 after:left-1/2 md:after:left-0 after:-translate-x-1/2 md:after:translate-x-0 after:w-12 after:h-[2px] after:bg-purple-500">
                Support
              </h3>
              <ul className="space-y-2.5 text-sm">
                {[
                  { name: "FAQs", path: "/Faq" },
                  { name: "Privacy Policy", path: "/privacyPolicy" },
                  { name: "Terms of condition", path: "/termsCondition" },
                ].map((link) => (
                  <li key={link.name} className="group/item flex justify-center md:justify-start">
                    {link.path ? (
                      <NavLink
                        to={link.path}
                        end
                        className={({ isActive }) =>
                          `inline-flex items-center gap-1.5 transition-all duration-200 cursor-pointer hover:text-purple-400 hover:translate-x-1 ${isActive ? "text-purple-400 font-semibold" : "text-gray-400"
                          }`
                        }
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-purple-500 opacity-0 group-hover/item:opacity-100 transition-opacity duration-200 shrink-0" />
                        {link.name}
                      </NavLink>
                    ) : (
                      <span className="inline-flex items-center gap-1.5 transition-all duration-200 cursor-pointer hover:text-purple-400 hover:translate-x-1 text-gray-400">
                        <span className="w-1.5 h-1.5 rounded-full bg-purple-500 opacity-0 group-hover/item:opacity-100 transition-opacity duration-200 shrink-0" />
                        {link.name}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Newsletter & Socials - Hidden on small screens, shown on large screens */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-white text-lg font-bold mb-5 relative after:content-[''] after:absolute after:-bottom-1.5 after:left-1/2 md:after:left-0 after:-translate-x-1/2 md:after:translate-x-0 after:w-12 after:h-[2px] after:bg-purple-500">
              Contact Info
            </h3>
            <ul className="w-full max-w-sm md:max-w-none space-y-3.5 text-sm text-gray-400 mt-2">
              {[
                {
                  icon: <FaEnvelope className="text-base" />,
                  label: "Email us",
                  value: (
                    <a
                      href="mailto:info@yoyogames.ca"
                      className="hover:text-purple-400 transition-colors cursor-pointer break-all"
                    >
                      info@yoyogames.ca
                    </a>
                  ),
                },
                {
                  icon: <FaPhoneAlt className="text-base" />,
                  label: "Call us",
                  value: (
                    <div className="flex flex-col gap-1">
                      <a
                        href="tel:1800-9797-6361"
                        className="hover:text-purple-400 transition-colors cursor-pointer"
                      >
                        1800-9797-6361
                      </a>
                      <a
                        href="tel:+15198817124"
                        className="hover:text-purple-400 transition-colors cursor-pointer"
                      >
                        1800-9797-9055
                      </a>
                    </div>
                  ),
                },
                {
                  icon: <FaMapMarkerAlt className="text-base" />,
                  label: "Location",
                  value: (
                    <div className="flex flex-col gap-2">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.google.com/maps/place/855+King+St+E+%23210,+Cambridge,+ON+N3H+3P2,+Canada/@43.3946841,-80.3558498,826m/data=!3m2!1e3!4b1!4m5!3m4!1s0x882b89f0377066e3:0x13fe980777df8121!8m2!3d43.3946841!4d-80.3558498?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D"
                        className="hover:text-purple-400 transition-colors cursor-pointer leading-tight"
                      >
                        855 King Street East, Unit 210, Cambridge, ON, Canada
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.google.com/maps/place/Shyam+Mandir+Rd,+Hukmchand+Nagar,+Althan,+Surat,+Gujarat+395007/@21.1460831,72.800298,1060m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3be05203d87284f1:0xc550f071f2d34a38!8m2!3d21.1460831!4d72.800298!16s%2Fg%2F11f2v569v2?entry=ttu&g_ep=EgoyMDI2MDQwMS4wIKXMDSoASAFQAw%3D%3D"
                        className="hover:text-purple-400 transition-colors cursor-pointer leading-tight text-[13px]"
                      >
                        402–405 Astha Shoppers, Near Bhagvan Mahavir College, Vesu, Surat – 395007 (Branch)
                      </a>
                    </div>
                  ),
                },
              ].map((item, index) => (
                <li
                  key={index}
                  className="flex items-start gap-4 p-3 rounded-xl bg-white/[0.02] border border-white/[0.04] hover:bg-white/[0.04] hover:border-purple-500/20 transition-all duration-300 group cursor-pointer"
                >
                  <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-500/10 text-purple-400 shrink-0 group-hover:bg-purple-500 group-hover:text-white transition-all duration-300">
                    {item.icon}
                  </div>
                  <div className="flex flex-col gap-1 text-left min-w-0">
                    <span className="text-[11px] font-semibold text-purple-400/80 uppercase tracking-wider">
                      {item.label}
                    </span>
                    <div className="text-[13px] text-gray-300 leading-normal font-medium">
                      {item.value}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            {/* <div className="flex mb-4">
              <input
                type="email"
                placeholder="Your email"
                className="px-3 py-2 w-full rounded-l-lg bg-[#0f0f11] border border-gray-700 focus:outline-none text-sm"
                required
              />
              <button type="submit" className="px-4 py-2 bg-purple-600 text-white text-sm rounded-r-lg hover:bg-purple-700 transition">
                Join
              </button>
            </div> */}
          </div>
        </div>
      </div>
      {/* Bottom Copyright */}
      <div className="border-t border-gray-700 mt-10 pt-4 text-center text-xs text-gray-500">
        &copy; {new Date().getFullYear()} YOYO GAMES. All rights reserved by VS Infotech Pvt Ltd.
      </div>
    </motion.footer>
  );
};

export default Footer;
